import { registeredFeatures } from "../../features";
import { IFeature } from "../../features/iFeature";
import { IMenuItem } from "../../models/interfaces";
import { PermissionStore } from "../../stores";
import { IStoreContext } from "../../stores/StoreContext";

export class NavigationService {
  private permissionStore: PermissionStore;

  constructor(storeContext: IStoreContext) {
    this.permissionStore = storeContext.permissionStore;
  }

  public get availableFeatures(): IFeature[] {
    if (!this.permissionStore) {
      return [];
    }

    return registeredFeatures.filter(feature => this.permissionStore!.hasRole(feature.requiredRole));
  }

  public get availableFeatureMenuItems(): IMenuItem[] {
    return this.availableFeatures.map(f => f.menuItem);
  }
}
